import { InvoiceResponseDto } from "../shared/dtos/invoice/InvoiceResponseDto";
import { InvoiceSummaryDto } from "../shared/dtos/invoice/InvoiceSummaryDto";

export class InvoiceMapper {
  public static mapInvoiceToSummary(
    invoice: InvoiceResponseDto,
  ): InvoiceSummaryDto {
    return {
      id: invoice.id,
      invoiceNumber: invoice.invoiceNumber,
      issueDate: invoice.issueDate,
      dueDate: invoice.dueDate,
      transactionStatus: invoice.transactionStatus,
      status: invoice.status,
      saleType: invoice.saleType,
      customerName: invoice.customerName,
      currencyCode: invoice.currencyCode,
      exchangeRate: invoice.exchangeRate,
      subtotal: invoice.subtotal,
      totalDiscount: invoice.totalDiscount,
      totalTaxableAmount: invoice.totalTaxableAmount,
      totalTax: invoice.totalTax,
      total: invoice.total,
      amountPaid: invoice.amountPaid,
    };
  }
}
